var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M496 176V16H16V176H496Z",
    fill: "#E32D3C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M496 336V176H16V336H496Z",
    fill: "#2980B9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M496 496V336H16V496H496Z",
    fill: "#E32D3C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M325.6 256C325.6 294.439 294.439 325.6 256 325.6C217.561 325.6 186.4 294.439 186.4 256C186.4 217.561 217.561 186.4 256 186.4C294.439 186.4 325.6 217.561 325.6 256V256Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLa);
export default __webpack_public_path__ + "static/media/LA.7212178c44807880b6fc6a5fd92a9a79.svg";
export { ForwardRef as ReactComponent };